// extracted by mini-css-extract-plugin
export default {"switchWrapper":"styles_switchWrapper__Z3AzY","slider":"styles_slider__DSZGU"};